import React, { useState, useCallback, useEffect } from "react"
import styles from "../../../styles/Page-with-Sidebar.module.css"
import { Button } from "primereact/button"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { LoaderSmall } from "../../../components/Loaders"
import { getTimeAgo, sortListByDate, truncateString } from "../Utils"

export default function BroadcastLeftConvList({
  openGroupConv,
  openNewBroadcastForm,
  groupConvList,
  loadingGroupList,
}) {
  const [filteredGroupConvList, setFilteredGroupConvList] = useState([])
  const [selectedGroupConvId, setSelectedGroupConvId] = useState(null)

  useEffect(() => {
    let list = groupConvList
    sortListByDate(list, "lastMessageOn")
    setFilteredGroupConvList(list)
  }, [groupConvList])

  const openConv = useCallback((broadcastGroupId) => {
    openGroupConv(broadcastGroupId)
  }, [])

  const openNewBroadcastView = useCallback(() => {
    openNewBroadcastForm()
    setSelectedGroupConvId(null)
  }, [])

  return (
    <div className={styles.conversations_menu} style={{ backgroundColor: "#e7e0f180", paddingRight: "10px" }}>
      <div style={{ display: "flex", justifyContent: "fex-end", alignItems: "center", height: "44px", marginBottom: "30px" }}>
        <Button
          className={`custom_button_icon ${gMessages.newChatBtn}`}
          label="New Broadcast"
          icon="pi pi-plus"
          onClick={() => openNewBroadcastView()}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3 style={{ color: "#383838", fontSize: "16px", fontWeight: "700" }}>Recents</h3>
      </div>
      {loadingGroupList === false &&
        filteredGroupConvList &&
        filteredGroupConvList.length === 0 &&
        <h3
          style={{
            marginTop: "20px",
            textAlign: "center",
            color: "#383838",
            fontSize: "20px"
          }}>No groups found</h3>
      }
      <ul className={`${gMessages.chatConvListContainer} ${gMessages.myScrollbar}`} >
        {loadingGroupList === true && <LoaderSmall></LoaderSmall>}
        {loadingGroupList === false &&
          filteredGroupConvList &&
          filteredGroupConvList.map((broadcastGroup) => (
            <li
              key={broadcastGroup.id}
              onClick={() => {
                openConv(broadcastGroup.id)
                setSelectedGroupConvId(broadcastGroup.id)
              }}
              style={{ width: "100%" }}
            >
              <div
                className={`${gMessages.convElement} ${selectedGroupConvId === broadcastGroup.id && gMessages.selected}`}>
                <div>
                  <p>{truncateString(broadcastGroup.groupName, 22)}</p>
                  <p className={gMessages.timeAgo}>{getTimeAgo(broadcastGroup.lastMessageOn)}</p>
                </div>
              </div>
            </li>
          ))}
      </ul>
    </div>
  )
}